export const GET_ITEM_CATEGORY_1 = "GET_ITEM_CATEGORY_1";
export const GET_ITEM_CATEGORY_2 = "GET_ITEM_CATEGORY_2";
export const GET_ITEM_CATEGORY_3 = "GET_ITEM_CATEGORY_3";
export const GET_ALL_CATEGORIES = "GET_ALL_CATEGORIES";